import { Route } from "react-router-dom";
import React from "react";

const ProtectedRoute = ({ path, exact, component: Component }) => (
    <Route path={path} exact={exact} render={props => <Component {...props} />} />
);

export default ProtectedRoute;
